<template>
  <div class="list">
    <div class="title">显示设置</div>
    <ul >

      <li class="item">
        <div class="content">
          <div class="content-text">
            <h3 class="content-title">供应链列表</h3>
          </div>
          <el-radio-group v-model="config.layoutCollectComp" @change="collectCompChange">
            <el-radio label="card">卡片形式</el-radio>
            <el-radio label="table">表格形式</el-radio>
          </el-radio-group>
        </div>
      </li>

  </ul>
  </div>
  
</template>

<script>

export default {
  props: {
    config: { default: {} }
  },
  data() {
    return {
      radio: 'card'
    }
  },
  methods: {
    collectCompChange(value) {
      this.configChange('layoutCollectComp', value);
    },

    configChange(key, value) {
      this.$emit('configChange', key, value);
    }
  },
}
</script>
<style lang="less" scoped>
  .title {
    color: #333;
    font-size: 14px;
    margin: 0;
    line-height: 28px;
    background: #fff;
    padding: 5px 20px;
    font-weight: 600;
  }
</style>

